module.exports = __webpack_public_path__ + "static/media/ceremonia.8c69aa34.svg";